// en_us.js英文文件
export default {
	message: {
		language: 'Lang',
		plogin: 'Please Login First！',
		login: 'Login',
		login1: 'Log in now',
		logintips: 'Experience more services after logging in',
		register: 'Register',
		register1: 'Register Now',
		loginout: 'LogOut',
		join: 'Join',
		days: 'days',
		lastip: 'Last login IP',
		account: 'Account',
		game: 'Game',
		video: 'Video',
		collect: 'Collect',
		Favorite: 'Favorite',
		collect1: 'Favorites',
		share: 'Share',
		sharelive: 'Share live',
		Cache: 'Cache',
		download: 'DownLoad',
		wallet: 'Wallet',
		recharge: 'Recharge',
		withdraw: 'Withdraw',
		noble: 'Noble',
		record: 'Record',
		RechargeTime: 'Recharge Time',
		WithdrawalTime: 'Withdrawal Time',
		RechargeRecord: 'Recharge Record',
		WithdrawalRecords: 'Withdrawal Records',
		TransactionRecords: 'Transaction Records',
		business: 'Business',
		message: 'Message',
		activity: 'Preferential',
		setting: 'Setting',
		help: 'Help',
		version: 'Version',
		loggingout: 'Logging Out',
		remember: 'Remember Password',
		forget: 'Forget Pawword',
		noaccount: 'No Account',
		returnhome: 'Return Home',
		bottomtips: 'Our group operates legally under the supervision of the Philippine PAGCOR and the British Isle of Man Gaming Association',
		days21: '21 years old and read and agree',
		rules: 'Rules and Conditions',
		hadaccount: 'Existing Account',
		gonggao: 'Notice',
		system: 'system',
		home: 'Home',
		kefu: 'Service',
		kefuCenter: 'Customer Service Center',
		mykf1desc: 'Please download the following exclusive app to add an ID and contact me',
		mykf2desc: 'Download Address',
		mykf3desc1: 'Online customer service',
		mykf3desc2: 'Click to start online chat',
		mykf3desc3: 'Dealing with recharge issues, withdrawals, and gaming issues',
		my: 'My',
		close: 'close',
		zuixin: 'Last',
		yhdetail: 'Offer Details',
		mywallet: 'My wallet',
		zichan: 'Property',
		yuan: 'CNY',
		zxwallet: 'Central Wallet',
		ptwallet: 'Platform Wallet',
		transfer: 'Transfer',
		LimitTransfer: 'Limit Transfer',
		cards: 'Card package Management',
		gamebalance: 'Game balance',
		onerecycle: 'One key recycle',
		Recovery: 'Recovery',
		Recycling: 'Recycling',
		wei: 'stand',
		loading: 'loading',
		refreshing: 'refreshing',
		refreshend: 'Refresh successful',
		success: 'success',
		czamount: 'recharge amount',
		limit: 'limit',
		saccount: 'Select Account',
		skbank: 'Receiving bank',
		skname: 'Name of payee',
		copy: 'Copy',
		skcard: 'Collection card number',
		submit: 'Submit',
		Confirmsubmit: 'Confirm Submit',
		nextstep: 'Next step',
		customerservice: 'Customer Service',
		pleasecontact: 'If you have any questions, please contact',
		copysuccess: 'Successfully copied to the clipboard',
		copyfail: 'Copy failed',
		firstmoney: 'Please enter the recharge amount first',
		rechargelowtips: 'The recharge amount cannot be less than the minimum limit',
		rechargeuptips: 'The recharge amount cannot exceed the maximum limit',
		firstaccount: 'Please select an account first',
		selwallet: 'Choose a wallet',
		firstoutwallet: 'Please select to transfer out the wallet first',
		retract: 'Up',
		expend: 'Down',
		mzmodel: 'No transfer mode',
		mzmodeltips: 'After activation, the balance will automatically be transferred to the game venue',
		seloutwallet: 'Transfer out the wallet',
		selinwallet: 'Transfer to wallet',
		transfertips: 'Venue wallets cannot be interchanged',
		maxamount: 'Maximum amount',
		codings: 'Typing quantity',
		washingAmount: 'Washing Amount',
		withamount: 'Withdrawal amount',
		banks: 'Bank Card',
		withzhtips: 'Please bind the withdrawal account first',
		withmoneytips: 'Please input the withdrawal amount first',
		add: 'Add',
		antoken1: "The world's leading virtual currency online wallet, with automatic real-time receipt of recharge and withdrawal, makes transfer transactions faster and safer",
		antoken2: 'AnToken Personal Wallet APP Download: Click to directly access the website',
		antoken3: 'https://antoken.pro',
		cardtips: 'Kind reminder: Each account can only be bound with 5 cards. If you want to modify it, please delete it and add it again！',
		walletaddress: 'Wallet address',
		walletaddressdesc: 'Please fill in the K bean address of the 34 digit English numeral combination starting from ec',
		USDTaddress: 'USDT address',
		unbindingtips: 'Are you sure you want to unbind？',
		paypass: 'Payment Pawwrod',
		cardprotocol: 'Wallet Protocol',
		cardaddress: 'Wallet Address',
		Cardholder: 'Cardholder',
		bankcard: 'Bank card number',
		bankname: 'Bank of deposit',
		banknamedesc: 'Please select the bank of deposit',
		bankaddress: 'Account Opening Address',
		bankaddressdesc: 'Please select an account opening address',
		bankother: 'Opening branch',
		firstpaypass: 'Please enter the payment password first',
		bindtips: 'Please fill in the information properly, and it cannot be modified after binding',
		Paymentcode: 'Payment code',
		platname: 'Tengda Entertainment',
		records: 'Recharge record',
		gameRecord: 'Game Record',
		betrecord: 'Game note',
		betDetail: 'Betting Details',
		accountsetting: 'Account Settings',
		messages: 'My message',
		returnrecord: 'Return water record',
		transferrecord: 'Transfer records',
		activityrecord: 'Activity Application Record',
		applyfor: 'Apply For',
		welfare: 'Welfare',
		query: 'Query',
		Time: 'Time',
		To: 'To',
		dllogin: 'Agent Login',
		outsuccess: 'Exit successfully',
		today: 'Today',
		days7: 'Last 7 days',
		days14: 'Last 14 days',
		days30: 'Last 30 days',
		cunkuan: 'deposit',
		qukuan: 'withdraw',
		ordersn: 'Order No.',
		money: 'amount',
		state: 'state',
		nomore: 'No more',
		More: 'More',
		SeeMore: 'See More',
		Detail: 'Detail',
		Changebatch: 'Change batch',
		Lovely: 'Guess you like it',
		selplatform: 'Select Platform',
		betamount: 'Betting amount',
		betgame: 'Game',
		betresult: 'Betting results',
		perfect1: 'Improve account information for greater security',
		perfect2: 'Improve personal information',
		perfect3: 'More complete information and thoughtful service',
		perfect4: 'To improve',
		binding: 'Binding',
		AddBinding: 'Add Binding',
		carding1: 'Card Management',
		carding2: 'If you need to withdraw, please bind your bank card or virtual currency address',
		logpassword1: 'Login password',
		logpassword2: 'Regularly modifying login passwords is beneficial for account security',
		paypassword1: 'Payment password',
		paypassword2: 'Regularly modifying payment passwords is beneficial for account security',
		oldloginpass: 'Original login password',
		newloginpass: 'New login password',
		oldloginpassdesc: 'Please enter the original login password',
		newloginpassdesc: 'Please enter a new login password',
		confirmpass: 'Confirm Password',
		confirmpassdesc: 'Please enter a confirmation password',
		oldpaypass: 'Original payment password',
		newpaypass: 'New payment password',
		oldpaypassdesc: 'Please enter the original payment password',
		newpaypassdesc: 'Please enter a new payment password',
		personalinformation: 'Edit Information',
		edit: 'Edit',
		SelectAll: 'Select All',
		Delete: 'Delete',
		avatar: 'Upload avatar',
		username: 'Username',
		userID: 'User ID',
		userIDdesc: 'Please enter the user ID',
		username1: 'Username',
		realname: 'Truename',
		nickname: 'Nickname',
		realname2: 'Truename',
		realname1: 'Name or Nickname',
		realname1desc: 'Please enter your name or nickname',
		realnamedesc: 'Please enter your name',
		nicknamedesc: 'Please enter a nickname',
		sex: 'Sex',
		birthday: 'Birthday',
		birthdaydesc: 'Please select a birthday',
		email: 'Email',
		phone: 'Phone',
		nationality: 'nationality',
		nationalitydesc: 'Please enter your nationality',
		education: 'Education',
		educationdesc: 'Please enter educational background',
		AnnualSalary: 'Annual Salary',
		AnnualSalarydesc: 'Please enter annual salary',
		work: 'Work',
		workdesc: 'Please enter a job',
		RegistrationTime: 'Registration Time',
		LastLogin: 'Last Login',
		operate: 'Operate',
		mail: 'mail',
		allplat: 'Full platform',
		upgrade: 'Upgrade',
		draw: 'Receive',
		Received: 'Received',
		totaldraw: 'Accumulated collection',
		undraw: 'Unclaimed',
		transin: 'Transfer in',
		transout: 'Transfer out',
		transtype: 'Select transaction type',
		walfareinfo: 'Red envelope situation',
		help1: 'Hi,Dear member users',
		help2: 'Welcome to the Help Center',
		help3: 'If the relevant issues remain unresolved, you can consult online customer service',
		ungot: 'Unqualified',
		got: 'Qualified',
		totalrecharge: 'Accumulated recharge',
		totalwater: 'flowing water',
		waterratio: 'Return water ratio',
		jinji: 'be promoted',
		lijin: 'cash gift',
		level: 'Level',
		hot: 'HOT',
		live: 'LIVE',
		slot: 'SLOT',
		chess: 'CHESS',
		sports: 'SPORTS',
		lottery: 'LOTTERY',
		fishing: 'FISHING',
		actrules: 'Activity Rules',
		accountlogin: 'Account password login',
		mobilelogin: 'Mobile quick login',
		password: 'Password',
		newpassword: 'Password',
		pleaseaccount: 'Please enter an account name',
		passtips: 'The password is 6-15 characters long and must consist of letters and numbers！',
		pleasepass: 'Please input a password',
		pleasetwcode: 'Please enter the text verification code',
		country: 'Country/Mobile',
		pleasemobile: 'Please enter your phone number',
		yzm: 'Code',
		pleaseyzm: 'Please enter your phone verification code',
		sendcode: 'Send code',
		currency: 'Currency',
		usernametips: 'Please enter 4-16 characters, including English numerals',
		currencytips: 'Please enter currency',
		againpass: 'Enter the above password again',
		ckmoney: 'depositAmount',
		ckdate: 'depositDate',
		redmoney: 'redPacketAmount',
		activitycenter: 'Activity',
		lucrative: 'Promotion',
		MemberManagement: 'Member Management',
		CommissionSettlement: 'Commission Settlement',
		CommissionRecords: 'Commission Records',
		FriendTransfer: 'Friend Transfer',
		nightMode: 'Night Mode',
		Mobileauth: 'Mobile authentication',
		Certified: 'Certified',
		nodata: "There's no data left",
		Sportslive: 'Sports live',
		MemberID: 'Member ID',
		MemberIDdesc: 'Please enter the member ID',
		friendID: 'Friend ID',
		friendIDdesc: 'Please enter your friend ID or phone number',
		findMember: 'Retrieve Members',
		Platformfees: 'Platform fees',
		PromotionalMaterials: 'Promotional Materials',
		copylink: 'Copy link address',
		SaveQRcode: 'Save QR code',
		interest: 'Interest',
		eliminate: 'Eliminate',
		Recommend: 'Recommend',
		new: 'New',
		searchfor: 'Search',
		searchfordesc: 'Please enter search content',
		find: 'Find',
		results: 'results',
		Cashier: 'Cashier',
		skip: 'skip',
		Enterimmediately: 'Enter immediately',
		APPlock: 'APP application lock',
		actTime: 'Activity time',
		confirm: 'Determine',
		platformtype: 'platform type',
		orderState: 'Status',
		gameName: 'game name',
		gameNamedesc: 'Please enter the game name',
		bettime: 'Betting time',
		validamount: 'Bet amount',
		winloss: 'Winning amount',
		betnum: 'Game number',
		normal: 'normal',
		abnormal: 'abnormal',
		betTotal: 'Total bet amount',
		winTotal: 'Total winning amount',
		Orderamount: 'Order amount',
		Orderbet: 'Place order volume',
		male: "male",
		female: "female",
		electron: "video games",
		Dailyvideo: "Daily video recommendations",
		Choicevideo: "Selected recommendations",
		videoList1: "Daily updates",
		videoList2: "Popular Best Video",
		videoList3: "Free Video", //Short video
		mydata1: "VIP Days",
		mydata2: "Amount of return water",
		waterAmount: "Return Amount",
		waterDate: "Return date",
		noblet1: 'Upgrade VIP immediately and enjoy unlimited high-definition viewing of the entire station',
		noblet2: 'First come, first served, hurry up and snap up',
		noblet3: 'Unlimited viewing, complimentary',
		noblet4: 'View purchase VIP records',
		noblet5: 'Click here',
		order1: 'order',
		Transamount: 'Transferable amount',
		Dailylimit: 'Daily limit',
		vipIDdesc: 'Please enter a member ID or phone number',
		Transferaccount: 'Transfer to account',
		Transfermoney: 'Transferred amount',
		Transfert1: 'Note: Participation in promotional activities and withdrawal restrictions will result in non receipt of funds',
		Transfert2: 'Note: After successful submission, the system will receive the payment within 10 minutes. If the payment is not received, please contact customer service ',
		amount: 'Money',
		receiptTime: 'Time',
		Transferfriends: 'Transfer out friends',
		Transferringfriends: 'Transferring to a friend',
		Descriptive: 'Descriptive information',
		exchangerate: 'Real time exchange rate',
		Accountbalance: 'Account balance',
		withdrawal: 'The required code size for withdrawal',
		commission: 'commission',
		Exchangerate: 'Exchange rate calculation',
		illustrate: 'illustrate',
		withdrawtilt1: 'The minimum withdrawal is 100. If not received, please contact online customer service in a timely manner.',
		withdrawtilt2: 'The withdrawal bank card must be the personal bank card, otherwise it cannot be credited.',
		tips: 'rompt',
		findvipt1: 'This function allows you to retrieve subordinate members who have not been successfully bound.',
		findvipt2: '限Bind subordinate members within 3 days of registration.',
		Totalplatformcost: 'Total platform cost',
		Winlamount: 'Win or loss amount',
		PlatformRate: 'Platform Rate',
		totalExpenses: 'Total expenses',
		commission1: 'Current commission ratio',
		commission2: 'Commission rate',
		Mycommission: 'My commission',
		totalRecharge: 'Total recharge',
		totalWithdraw: 'Total withdrawal',
		totalPeople: 'Membership',
		activePeople: 'Active members',
		addPeople: 'New additions',
		SettlementDate: 'Settlement date',
		DayMonth: 'Day / Month',
		ImmeSettle: 'Immediate settlement',
		Formula: 'Formula',
		SettleMoney: 'Received commission amount',
		Date: 'Date',
		authname: 'Certified Name',
		authnamedesc: 'Please fill in the name of the remitter',
		hashelp: 'If you need help',
		contact: 'contact service',
		Agreement: 'Agreement/Currency',
		ckNumber: 'Number',
		cbaddress: 'Address',
		notes: 'Notes',
		Scancoins: 'Scan Code',
		content: 'Content',
		ckdesc: 'Please enter deposit details',
		zfAccount: 'Payment Account',
		zfbank: 'Paying Bank',
		banktype: 'Recharge type',
		banktypedesc: 'Please select a recharge type',
		zzzh: 'Transfer out',
		zjzh: 'retreat',
		whole: 'whole',
		zzmoney: 'Amount',
		zhtime: 'Time',
		zzpt: 'Platform',
		Paymentmethod: 'Payment Method',
		behalf: 'Friend Payment',
		saccountdesc: 'Please select a receiving account',
		cztips: 'Please transfer the amount to the above account before submitting the form, and the staff will handle it for you as soon as possible.',
		currency1: 'currency',
		exchangeRate1: 'Rate',
		Rebate: 'Rebate',
		Receive1: 'Recharge',
		PaymentVoucher: 'Upload payment voucher',
		DepositTime: 'Deposit time',
		DepositTimedesc: 'Please select a deposit time',
		BlockchainID: 'Blockchain ID',
		BlockchainIDdesc: 'Please enter the blockchain ID',
		tradeID: 'Last six digits of transaction ID',
		tradeIDdesc: 'Please enter the last six digits of the transaction ID',
		withdraw1: 'Withdrawal to account',
		gamenoIndesc: 'The game is under maintenance. Please try again later~',
		cznamedesc1: 'For the first online recharge, a real name must be bound.',
		cznamedesc2: 'Please ensure that this name matches the name of the depositor, otherwise the account cannot be credited.',
		cznamedesc3: 'After submitting and saving, it cannot be changed. Please fill it out carefully.',
		txnamedesc1: 'For the first time binding information, the real name must be bound.',
		txnamedesc2: 'Please ensure that this name matches the name of the person making the withdrawal, otherwise it will not be credited.',
		txnamedesc3: 'After submitting and saving, it cannot be changed. Please fill it out carefully.',
		modify: 'Modify',
		inviteId: 'InviteId',
		findpaypass: 'Retrieve payment password',
		Movies: 'Movies',
		rakeback: 'Rakeback',
		rescue: 'Rescue',
		RedeemCode: 'RedeemCode',
		dhTitle: 'My redemption Records',
		dhtxt: 'exchange',
		dhtxtbtn: 'Redeem now',
		dhtxtdesc: 'Enter redemption code',
		dhmoney: 'Exchange amount',
		dhlsbs: 'Flowing multiple',
		lqtime: 'Collection time',
		free: 'Free',
		zznamedesc1: 'Please make sure to fill in the real name of the transferor, otherwise automatic transfer will not be possible.',
		zznamedesc2: 'If the recharge amount is not received within 10 minutes, please contact online customer service.',
		tgrs: 'Current number of promoters',
		tglink: 'Promotion link',
		tgyqewm: 'Invitation QR code',
		wxts: 'Tips',
		tgtips1: 'To apply for an independent domain name, please contact the agent specialist.',
		tgtips2: 'If you are a webmaster and need advertising materials, please contact customer service.',
		tgtips3: 'Inviting friends to register, simply ask them to fill in the invitation code during registration.',
		mycenter: 'Personal Center',
		myInfo: 'Personal information',
		mylucrative: 'My promotion',
		Security: 'Account security',
		timeframe: 'Time frame',
		starttime: 'StartTime',
		endtime: 'EndTime',
		Keysdesc: "Please select a country",
		Keysdesc1: "Please select area code",
		rule1: '21 years old and read and agree',
		rule2: '【Rules and Terms】',
		autotrans: 'Automatic No Transfer',
		autotranstips: 'During the game, the balance will be automatically transferred to the corresponding game account',
		handtrans: 'Manual transfer',
		handtranstips: 'If manual transfer is required, please turn off 【 Automatic No Transfer 】',
		jytype: 'Transaction type',
		wechat: 'Wechat',
		Alipay: 'Alipay',
		yjed: 'Commission amount',
		yjsed: 'Settled credit limit',
	},
	footer: {
		fkfs: 'Payment Methods',
		partners: 'Partners',
		followUs: 'Follow Us',
		regauth: 'Regulatory Authority',
		pagcor: 'PAGCOR',
		legalage: 'Legal Age',
		cs: 'CS',
		telegram: 'Telegram',
		network: 'Network',
		dark: 'Dark',
		byday: '白天',
		affiliate: 'Affiliate',
		TOP: 'TOP',
		chat: 'Chat',
	},
	home: {
		hotgametit: "POPULAR Games",
		activitydesc1: "Tengda Super Gift",
		activitydesc2: "Call on friends and gather together to earn lottery money",
		new: "New",
		Chesscardsdesc1: "Chess and Cards",
		Chesscardsdesc2: "Realistic game experience, ",
		Chesscardsdesc3: "realistic AI to play with, ",
		Chesscardsdesc4: "multiple modes and new ways to play",
		Chesscardsdesc5: "High end chess and card games, super popular platform",
		lotterydesc1: "Lottery",
		lotterydesc2: "with classic and innovative lottery games,",
		lotterydesc3: "which will add lust  to your game process",
		onsitedesc1: "LIVE CASINO",
		onsitedesc2: 'We adhere to the concept of "service first" and are committed to providing services for our members and players',
		onsitedesc3: "The most diverse online gambling games and diverse high-value service systems",
		placeholderdesc: "Please enter the gameName",
		gogamebtn: "Enter the game",
		swgamebtn: "Try playing games",
		swbtn: "Demo",
		egamesdesc1: "Pocket Games Soft",
		egamesdesc2: "The world's leading electronic game supplier, ",
		egamesdesc3: "mainly engaged in offline and online electronic game development. ",
		egamesdesc4: "Owns the largest entertainment city in Asia",
		livedesc1: "Casino Live",
		livedesc2: "AG ALLBET  OG DS ",
		livedesc3: "Top entertainment platform",
		livedesc4: "You can choose from various gameplay tables such as Dragon Tiger, Fried Golden Flower, Colorful Dish, and Fantan,",
		livedesc5: "Let you have an immersive luxury experience!",
		sportdesc1: "Sports",
		sportdesc2: "The most types of betting, the strongest betting experience,",
		sportdesc3: "support for cashing out in advance, ",
		sportdesc4: "one step faster in collecting rice, think what you think, ",
		sportdesc5: "vote what you love.",
		fishdesc1: "Fishing",
		fishdesc2: "Fishing spree! Super high explosion",
		fishdesc3: "rate, massive treasures waiting for you to catch!",
		tiptitle: 'Important Reminder',
		tipclose: 'Close',
		tipflag: "Don't remind today",
		testdesc1: "Latest official website",
		testdesc2: "Kind reminder: The website with the minimum MS value will open faster!",
		LinkTimeout: "Link Timeout",
		GoImmediately: "Go Immediately",
		Recheck: "Recheck access speed",
		Enter: 'Enter',
	},
	help: {
		title0: 'About Us',
		title1: 'Common Problem',
		title2: 'Privacy Policy',
		title3: 'Disclaimer',
		title4: 'Contact Us',
		title5: 'Agent Join',
		title6: 'Gaming Responsibility',
		title7: 'Business Cooperation',
		service: 'Online Service',
		servicedesc: 'Fast, convenient, and timely communication',
	},
	download: {
		scantxt: 'Scan the QR code to download the APP',
		downtext: "APP Download",
		downdesc: "Open an TDBET account immediately and enjoy the most favorable bonuses!",
		version: "Version",
		ScanCodedown: "Scan code to download the App",
		BeCurrent: "Be Current",
		H5org: "H5 Page Access",
	},
	vip: {
		viptitle: "Tengda VIP",
		viptitle1: "Summit Ceremony",
		viptitle2: "Glory sets sail",
		viptitle3: "Join Tengda VIP to enjoy top-notch and top-notch services",
		vipen: "BECOME A VIP MEMBER AND ENJOY THE MOST HONORBLE SERVICE",
		totalDeposit: "totalDeposit",
		totalBet: "totalBet",
		vipBLdesc: "VIP ReturnWaterRatio",
		vipgradetitle: "VIP Grade",
		vipgrade1: "Live",
		vipgrade2: "Egames",
		vipgrade3: "Chesscards",
		vipgrade4: "Sports",
		vipgrade5: "Lottery",
		vipgrade6: "Esports",
		ActivityRules: "Activity Rules",
		Rulestext1: "Promotion criteria",
		Rulesdesc1: "If a member's cumulative deposits and cumulative flow meet the requirements of the corresponding level, they can be promoted to the corresponding VIP level before 24:00 the next day.",
		Rulestext2: "Promotion order",
		Rulesdesc2: "VIP level can be promoted once a day if it meets the corresponding requirements, but VIP level cannot be promoted beyond the level.",
		Rulestext3: "Classification requirements",
		Rulesdesc3: "After reaching a certain VIP level, members need to complete the level guarantee flow requirement for betting within 90 days. If promotion is completed during this period, the promotion requirement will be recalculated based on the current level.",
		Rulestext4: "Downgrade standard",
		Rulesdesc4: "If a member fails to meet the corresponding classification requirements within a quarter (calculated within 90 days), the system will automatically downgrade by one level, and the corresponding rebate and other discounts will also be adjusted to the downgraded level.",
		Rulestext5: "Upgrade gift money",
		Rulesdesc5: "The upgrade gift will be automatically distributed by the system after the member reaches the member level. Each member can only receive one upgrade gift for each level (one time the upgrade gift can be withdrawn).",
		Rulestext6: "Birthday gift",
		Rulesdesc6: "Members who celebrate their birthdays within three months of registration will not be able to receive birthday gifts this year. Members who have registered for more than three months need to self collect on the VIP page on their birthday, which can be collected once a year. (The birthday gift can be withdrawn by doubling the running amount).",
		Rulestext7: "Monthly red envelope",
		Rulesdesc7: "Members who have made at least one successful deposit record in the previous month can go to the VIP page on the 1st and 16th of the following month to collect 1/2 of the corresponding level of monthly red envelope lottery on that day (withdrawal can be made by doubling the amount of the red envelope gift)",
		Rulestext8: "Tengda Entertainment reserves the right to modify, stop, and ultimately explain the event.",
		Rulesdesc8: "Note: The above is the maximum return water for each venue. The specific amount of return water is subject to the actual game. Daily return water will be distributed from 15:00 to 16:00 the next day.",

	},
}


// WEBPACK FOOTER //
// ./src/lang/en_us.js